/**
 * @author Hiroki Moto
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { filter, find, propEq } from 'ramda';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import * as BadgeCard from '@components/LibraryProgramsBadge';
import * as CareerCard from '@components/LibraryProgramsCareer';
import * as CertificationCard from '@components/LibraryProgramsCertification';
import { AppActions, DevelopActions } from '~/actions';
import withNavigate from '~/hocs/withNavigate';

class ProgramAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = { type: props.match?.params?.activeTab };
    }

    render() {
        const { authors, departments, competencies, categories, company, companies, modalData } = this.props;
        const { type } = this.state;
        const tags = { authors, departments, competencies, categories };
        const quotaOptions = filter((x) => !x.label.includes('Quarter'), this.props.quotaOptions);
        const _company = find(propEq('id', company.id), companies);
        const jobRoles = _company.job_roles;

        return (
            <ErrorBoundary>
                {type === 'careers' && (
                    <CareerCard.Add
                        company={company}
                        tags={tags}
                        jobs={jobRoles}
                        quotaOptions={quotaOptions}
                        navigate={this.props.navigate}
                        location={this.props.location}
                        modalData={modalData}
                        onSave={(e, image) => this.props.saveProgram(e, image)}
                        onModal={(e) => this.props.toggleModal(e)}
                    />
                )}
                {type === 'certifications' && (
                    <CertificationCard.Add
                        company={company}
                        tags={tags}
                        quotaOptions={quotaOptions}
                        navigate={this.props.navigate}
                        location={this.props.location}
                        modalData={modalData}
                        onSave={(e, image, pdf) => this.props.saveProgram(e, image, pdf)}
                        onModal={(e) => this.props.toggleModal(e)}
                    />
                )}
                {type === 'badges' && (
                    <BadgeCard.Add tags={tags} navigate={this.props.navigate} location={this.props.location} onSave={(e) => this.props.saveProgram(e)} onModal={(e) => this.props.toggleModal(e)} />
                )}
            </ErrorBoundary>
        );
    }
}

ProgramAdd.propTypes = {
    authors: PropTypes.array,
    company: PropTypes.shape({
        id: PropTypes.number,
    }),
    categories: PropTypes.array,
    departments: PropTypes.array,
    competencies: PropTypes.array,
    saveProgram: PropTypes.func,
    toggleModal: PropTypes.func,
};

ProgramAdd.defaultProps = {
    authors: [],
    company: {
        id: 0,
    },
    categories: [],
    departments: [],
    competencies: [],
    saveProgram: () => {},
    toggleModal: () => {},
};

const mapStateToProps = (state) => ({
    authors: state.app.authors,
    company: state.app.company_info,
    companies: state.app.companies,
    categories: state.app.categories,
    departments: state.app.departments,
    competencies: state.app.competencies,
    quotaOptions: state.develop.libraryQuotaOptions,
    modalData: state.app.modalData,
});

const mapDispatchToProps = (dispatch) => ({
    saveProgram: (e, image, pdf) => dispatch(DevelopActions.librarysaveRequest(e, image, pdf)),
    toggleModal: (e) => dispatch(AppActions.modalRequest(e)),
});

const ProgramAddWithNavigate = withNavigate(ProgramAdd);

export default connect(mapStateToProps, mapDispatchToProps)(ProgramAddWithNavigate);
